// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgn_a bht_vt bht_ea bht_a","MenuItem__Btn":"bgn_b bht_z","MenuItem__subtitle":"bgn_c"};